export enum EnumFeaturesActionsDestinations {
    Geofences = "Geofences",
    Tool = "Tool",
    Potential_Zones = "PotentialZones",
    Territories = "Territories",
    Ninguno = ""
}